<button mat-button class="btn_secondary_filled"
  [ngClass]="{'btn_secondary_filled_icon-right': !iconPosition, 'btn_secondary_filled_icon-left': iconPosition}"
  [disabled]="disabled" (click)="onClick()">
  
  <!-- Icono de Material Design (outlined o rounded) -->
  <mat-icon [class]="iconClass" *ngIf="icon && typeIcon !== 'customized'">{{ icon }}</mat-icon>
  
  <!-- Icono personalizado (URL) -->
  <img *ngIf="icon && typeIcon === 'customized'" 
       [src]="icon" 
       [alt]="label + ' icon'"
       class="custom-icon">
  
  {{ label }}
</button>